import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ServiciosGeneralesService } from 'projects/modulo-solicitudes/src/core/servicios/servicios-generales.service';
import { debounceTime } from 'rxjs/operators';
import {Catalogo,General} from '../../interfaces/general'
import { Store } from '@ngrx/store';
import { datosSolicitante } from '../../interfaces/solicitudes';
import * as SolicitudesActions from '../../ngrx/solicitudes.action'
import { SolicitudesService } from '../../servicios/solicitudes.service';
import { Router, ActivatedRoute } from '@angular/router';

interface iSolicitudProgreso {
	Convocatoria_ID?:number,
    Curp?: string
}

@Component({
  selector: 'app-persona',
  templateUrl: './persona.component.html',
  styleUrls: ['./persona.component.css']
})
export class PersonaComponent implements OnInit {
	personaFormulario: FormGroup;
	tieneCURP: boolean = false
	tieneDiscapacidad: boolean = false;
	municipios: any
	idEstado;
	extranjeroEs = false
	pais:string
	paises : any
	idSolicitud: number;
	ListaDiscapacidades = [];
	firstTime:boolean
	telefonos = {DatosContacto_TelefonoFijo:'' , DatosContacto_TelefonoCelular: ''}
	@Input() catalogos: General
	@Input() estadosCiviles: Array<Catalogo>
	@Input() tipoPersona: number;
	@Input() parentescos: Array<Catalogo>
	@Input() situacionesLaborales: Array<Catalogo>
	@Input() oficios: Array<Catalogo>
	@Input() estados: Array<any>

	constructor(private formBuilder: FormBuilder,
				private serviciosGenerales: ServiciosGeneralesService,
				private store: Store<datosSolicitante>,
				private serviciosSolicitud: SolicitudesService,
				private route: Router,
				private router: ActivatedRoute ) {
		this.crearFormulario();
		console.log(this.estados)
	}

	ngOnInit(): void {
		this.cambioCURP()
		this.formulariosPorID(this.tipoPersona);
		// this.personaFormulario.disable();
		// this.personaFormulario.controls.Personas_Nombre.disable();
		// this.personaFormulario.controls.Personas_ApellidoPaterno.disable();
		// this.personaFormulario.controls.Personas_ApellidoMaterno.disable();
		// this.personaFormulario.controls.Personas_EntidadFederativaID.disable();
		// this.personaFormulario.controls.Personas_MunicipioID.disable();
		// this.personaFormulario.controls.Personas_Genero.disable();
	}

	idEstadoMunicipioCURP (estadoID, MunicipioID) {
		const idEstadoDB = this.estados.filter(estado => +estado.Codigo === +estadoID)
		console.log(idEstadoDB)
		this.serviciosGenerales.listadoMunicipios(idEstadoDB[0].ID).subscribe((res) => {
			this.municipios = res
			const idMunicipioID = this.municipios.filter(municipio => +municipio.Codigo === +MunicipioID)
			this.personaFormulario.get('Personas_EntidadFederativaID').setValue(idEstadoDB[0].ID);
			this.personaFormulario.get('Personas_MunicipioID').setValue(idMunicipioID[0].ID);
		});
	}
	cambioCURP(): void {
		this.personaFormulario.get('Personas_CURP').valueChanges.pipe(
			debounceTime(1500)
		).subscribe(CURP => {
			const solicitud:iSolicitudProgreso =  {
				Convocatoria_ID:1001,
				Curp: CURP
			}

			return  (CURP.length === 18) ? this.verEstadoSolicitud(solicitud) : ''
		})
	}

	/**
	* Metodo para generar el formulario reactivo
	*/
	crearFormulario() {
		this.personaFormulario = this.formBuilder.group({
			Personas_CURP: ['',Validators.required],
			Personas_Nombre: ['', ''],
			Personas_ApellidoPaterno: ['', ''],
			Personas_ApellidoMaterno: ['', ''],
			Personas_EntidadFederativaID: ['',Validators.required],
			Personas_MunicipioID: ['', ''],
			Personas_EstadoCivilID: ['',Validators.required],
			Personas_Genero: ['', ''],
			Personas_PaisID: ['', ''],
			DatosContacto_Correo: ['',Validators.compose([Validators.email, Validators.required])],
			Solicitante_SituacionPadreID: ['',Validators.required],
			Solicitante_SituacionMadreID: ['', Validators.required],
			Persona_RFC: ['',Validators.required],
			SolicitantePersona_ParentezcoID: ['',Validators.required],
			Direccion: this.formBuilder.group({
				Direcciones_EntidadFederativaID: ['',Validators.required],
				Direcciones_MunicipioID: ['',Validators.required],
				Direcciones_LocalidadID: ['',Validators.required],
				Direcciones_CodigoPostal: ['',Validators.required],
				Direcciones_ColoniaID: ['',Validators.required],
				Direcciones_CalleID: ['',Validators.required],
				Direcciones_AsentamientoID: ['',Validators.required],
				Direcciones_CarreteraID: ['',Validators.required],
				Direcciones_CaminoID: ['',Validators.required],
				Direcciones_NoExterior: ['',Validators.required],
				Direcciones_NoInterior: ['', ''],
				Direcciones_Calle: ['',Validators.required],
				Direcciones_Latitud: ['', ''],
				Direcciones_Longitud: ['', '']
			}),
			DireccionEmpresa: this.formBuilder.group({
				Direcciones_EntidadFederativaID: ['',Validators.required],
				Direcciones_MunicipioID: ['',Validators.required],
				Direcciones_LocalidadID: ['',Validators.required],
				Direcciones_CodigoPostal: ['',Validators.required],
				Direcciones_ColoniaID: ['',Validators.required],
				Direcciones_CalleID: ['',Validators.required],
				Direcciones_AsentamientoID: ['',Validators.required],
				Direcciones_CarreteraID: ['',Validators.required],
				Direcciones_CaminoID: ['',Validators.required],
				Direcciones_NoExterior: ['',Validators.required],
				Direcciones_NoInterior: ['',''],
				Direcciones_Calle: ['',Validators.required],
			}),
			DatosEscolaresLaborales: this.formBuilder.group({
				DatosEscolares_NivelID: ['',Validators.required],
				DatosEscolares_EscuelaID: ['',Validators.required],
				DatosEscolares_CarreraID: ['',Validators.required],
				DatosEscolares_TipoPeriodoID: ['',Validators.required],
				DatosEscolares_PeriodoActual: ['',Validators.required],
				DatosEscolares_TotalPeriodos: ['',Validators.required],
				DatosEscolares_Promedio: ['',Validators.required],
				DatosLaborales_SituacionLaboral_ID: ['',Validators.required],
				DatosLaborales_Empresa: ['',Validators.required],
				DatosLaborales_Telefono: ['',Validators.required],
				DatosLaborales_Ocupacion_ID: ['',Validators.required],
				DatosLaborales_IngresoMensual: ['',Validators.required]
			}),
			Empresa_Telefono: ['',Validators.required],
			Empresa_Observaciones: ['',''],
			Persona_OcupacionID: ['',Validators.required],
      Persona_Ingresos: ['',Validators.required],
      Persona_Empresa: ['',Validators.required],
		});
	}
	formulariosPorID(formularioID) {
		if (formularioID !== 1 &&  formularioID !== 5 && formularioID !== 6
			&& formularioID !== 7) {
				this.personaFormulario.controls.Direccion.disable();
			}
		if(formularioID !== 1) {
			this.personaFormulario.controls.Solicitante_SituacionPadreID.disable();
			this.personaFormulario.controls.Solicitante_SituacionMadreID.disable();

		}
		if (formularioID !== 5) {
			this.personaFormulario.controls.DireccionEmpresa.disable();
			this.personaFormulario.controls.Empresa_Telefono.disable();
			this.personaFormulario.controls.Empresa_Observaciones.disable();
			this.personaFormulario.controls.Persona_Empresa.disable();
			this.personaFormulario.controls.Persona_Ingresos.disable();
			this.personaFormulario.controls.Persona_OcupacionID.disable();
			this.personaFormulario.controls.SolicitantePersona_ParentezcoID.disable();
			this.personaFormulario.controls.Persona_RFC.disable();
		}
		if (formularioID !== 9) {
			this.personaFormulario.controls.DatosEscolaresLaborales.disable();
		}
	}
	setValues(solicitud) {
		console.log(solicitud)

		if(this.tipoPersona === 1){
			this.telefonos = {
				DatosContacto_TelefonoFijo : solicitud.DatosSolicitante.DatosContacto_TelefonoFijo ,
				DatosContacto_TelefonoCelular: solicitud.DatosSolicitante.DatosContacto_TelefonoCelular ,
			}
			this.listarMunicipios(solicitud.DatosSolicitante.Personas_EntidadFederativaID)
			this.personaFormulario.get('Personas_Nombre').setValue(solicitud.DatosSolicitante.Personas_Nombre);
			this.personaFormulario.get('Personas_ApellidoPaterno').setValue(solicitud.DatosSolicitante.Personas_ApellidoPaterno);
			this.personaFormulario.get('Personas_ApellidoMaterno').setValue(solicitud.DatosSolicitante.Personas_ApellidoMaterno);
			this.personaFormulario.get('Personas_Genero').setValue(solicitud.DatosSolicitante.Personas_Genero);
			this.personaFormulario.get('Personas_EntidadFederativaID').setValue(solicitud.DatosSolicitante.Personas_EntidadFederativaID);
			this.personaFormulario.get('Personas_MunicipioID').setValue(solicitud.DatosSolicitante.Personas_MunicipioID);
			this.personaFormulario.get('Personas_EstadoCivilID').setValue(solicitud.DatosSolicitante.Personas_EstadoCivilID)
			this.personaFormulario.get('DatosContacto_Correo').setValue(solicitud.DatosSolicitante.DatosContacto_Correo)
			this.personaFormulario.get('DatosContacto_Correo').setValue(solicitud.DatosSolicitante.DatosContacto_Correo)
		}
		if(this.tipoPersona === 2) {
			this.personaFormulario.get('Personas_Nombre').setValue(solicitud.DatosSolicitante.Personas_Nombre);
			this.personaFormulario.get('Personas_ApellidoPaterno').setValue(solicitud.DatosSolicitante.Personas_ApellidoPaterno);
			this.personaFormulario.get('Personas_ApellidoMaterno').setValue(solicitud.DatosSolicitante.Personas_ApellidoMaterno);
			this.personaFormulario.get('Personas_Genero').setValue(solicitud.DatosSolicitante.Personas_Genero);
			this.personaFormulario.get('Personas_EntidadFederativaID').setValue(solicitud.DatosSolicitante.Personas_EntidadFederativaID);
			this.personaFormulario.get('Personas_MunicipioID').setValue(solicitud.DatosSolicitante.Personas_MunicipioID);
			this.personaFormulario.get('Personas_EstadoCivilID').setValue(solicitud.DatosSolicitante.Personas_EstadoCivilID)
			this.personaFormulario.get('DatosContacto_Correo').setValue(solicitud.DatosSolicitante.DatosContacto_Correo)
			this.personaFormulario.get('DatosContacto_Correo').setValue(solicitud.DatosSolicitante.DatosContacto_Correo)
		}

		// this.personaFormulario.disable();
		this.actualizarFormulario()

	}
	verEstadoSolicitud (datos) {

		this.serviciosSolicitud.obtenerSolicitudProgreso(datos).subscribe(res => {

			if(res.Solicitud_Progreso) {
				console.log('here')
				this.tieneCURP = true
				// this.obtenerdatosCURP(datos.Curp)

				const solicitud = res.Resultado
				console.log(solicitud)
				this.setValues(solicitud)
				this.idEstadoMunicipioCURP(solicitud.DatosSolicitante.Personas_EntidadFederativaID, solicitud.DatosSolicitante.Personas_MunicipioID)
				this.store.dispatch(SolicitudesActions.obtenerDatos(solicitud))

				// this.personaFormulario.controls.Personas_Nombre.disable();
				// this.personaFormulario.controls.Personas_ApellidoPaterno.disable();
				// this.personaFormulario.controls.Personas_ApellidoMaterno.disable();
				// this.personaFormulario.controls.Personas_EntidadFederativaID.disable();
				// this.personaFormulario.controls.Personas_MunicipioID.disable();

			}

		},res => {
			console.log(res.error)
			if(res.error.Solicitud_Existe === false && res.error.Solicitud_Progreso === false) {
				this.obtenerdatosCURP(datos.Curp)
				this.tieneCURP = true
			}

		}, () => {

		})
	}
	listarMunicipios(idEstado: number) {

		this.serviciosGenerales.listadoMunicipios(idEstado).subscribe((res) => {
			this.municipios = res;
		});
	}
	obtenerdatosCURP(CURP: string) {
		this.tieneCURP = false;
		this.serviciosGenerales.obtenerDatosCURP(CURP).subscribe((res) => {

				this.tieneCURP = res.Ok;
				if(this.tieneCURP) {
					if(res.Data.Country === "MEX") {
						this.mostrarInformacion(res.Data)
						this.obtenerListaEstadosID()
						this.extranjeroEs = false;
					} else {
						this.pais = res.Data.Country
						this.extranjeroEs = true;
						this.mostrarInformacion(res.Data)
						this.obtenerPaises();
					}
					this.actualizarFormulario()
				} else {
					console.log('Snackbar')
				}
		})
	}

	confirmarCorreo(correo: string, correoC: string) {
		return (formGroup: FormGroup) => {
			const c = formGroup.controls[correo];
			const cc = formGroup.controls[correoC];
			if (cc.errors && !cc.errors.confirmarCorreo) {
				return;
			}
			if (c.value !== cc.value) {
				cc.setErrors({confirmarCorreo: true});
			} else {
				cc.setErrors(null);
			}
		};
	}

	obtenerListaEstadosID () {

		const estado = this.estados.filter(estado => +estado.Codigo === +this.personaFormulario.value.Personas_EntidadFederativaID)
		console.log(estado)
	}

	obtenerPaises ():void {
		this.serviciosGenerales.listadoPaises().subscribe(res => {
			this.paises = res
			const pais = this.paises.filter(pais => pais.ISO_A3 === this.pais)
			this.personaFormulario.get('Personas_PaisID').setValue(pais.ID);
		});
	}

	agregarDiscapacidades(nuevasDiscapacidades) {
		this.ListaDiscapacidades = nuevasDiscapacidades
		this.actualizarStore()
		// this.store.dispatch(SolicitudesActions.solicitante(persona))
	}
	obtenerTelefonos(telefonos) {
		console.log(telefonos)
		this.telefonos = telefonos
		this.actualizarStore()
	}
	mostrarInformacion(persona) {

		console.log(persona)
		if (persona !== undefined) {
			this.idEstadoMunicipioCURP(+persona.StateId, persona.CityId)
			this.personaFormulario.get('Personas_Nombre').setValue(persona.Name);
			this.personaFormulario.get('Personas_ApellidoPaterno').setValue(persona.Lastname);
			this.personaFormulario.get('Personas_ApellidoMaterno').setValue(persona.Surname);
			// this.personaFormulario.get('Personas_EntidadFederativaID').setValue(+persona.StateId);
			// this.personaFormulario.get('Personas_MunicipioID').setValue(+persona.CityId);
			this.personaFormulario.get('Personas_Genero').setValue(persona.Genre);
			this.actualizarStore();
		}
	}
	actualizarStore() {
		let persona = this.personaFormulario.value;
		console.log(persona.Personas_EntidadFederativaID);

		if(this.tipoPersona === 1) {
			persona.ListaDiscapacidades = this.ListaDiscapacidades
			const {DatosContacto_TelefonoFijo, DatosContacto_TelefonoCelular} = this.telefonos
			persona.DatosContacto_TelefonoFijo = DatosContacto_TelefonoFijo
			persona.DatosContacto_TelefonoCelular = DatosContacto_TelefonoCelular
			if(typeof persona.Direccion.Direcciones_LocalidadID ===  'object') {
				console.log(persona.Direccion)
				persona.Direccion.Direcciones_LocalidadID = persona.Direccion.Direcciones_LocalidadID.ID
			}
		}
		switch(this.tipoPersona) {
			case 1:
				this.store.dispatch(SolicitudesActions.solicitante({solicitante: persona}))
			break;
			case 2:
				this.store.dispatch(SolicitudesActions.padre(persona))
			break;
			case 3:
				this.store.dispatch(SolicitudesActions.madre(persona))
			break;
			case 4:
				this.store.dispatch(SolicitudesActions.tutor(persona))
			break;
			case 5:
				this.store.dispatch(SolicitudesActions.avales(persona))
			break;
			case 6:
				this.store.dispatch(SolicitudesActions.personasViviendoJuntas(persona))
			break;
			case 7:
				this.store.dispatch(SolicitudesActions.refFamiliares(persona))
			break;
			case 8:
				this.store.dispatch(SolicitudesActions.refPersonales(persona))
			break;
			case 9:
				this.store.dispatch(SolicitudesActions.dtosEscolaresLaborales(persona.DatosEscolaresLaborales))
			break;
		}
	}
	obtenerIdEstado(idCURP) {
		console.log(this.estados)
		const estado = this.estados.filter(estado => +estado.Codigo === idCURP)
		console.log(estado)
	}
	actualizarFormulario() {
		this.personaFormulario.valueChanges.subscribe(valores => {
			console.log('a')
			this.actualizarStore();
		});
	}

	obtenerID() {
		this.router.paramMap.subscribe(params => {
			if (params.has('id')) {
				this.idSolicitud = +params.get('id');
				this.serviciosSolicitud.obtenersolicitudId(this.idSolicitud).subscribe(solicitud => {
					console.log('solicitud', solicitud)
				})
			}
		})
	}

	}


